<ng-container *transloco="let t; read:'permit.details.comments.createModal'">
    <div class="modal">
        <div class="modal__content">
            <label for="comment">{{ t("comment") }}</label>
            <textarea id="comment" name="comment" #comment class="modal__content__comment" [(ngModel)]="text" rows="5" enterkeyhint="done" [placeholder]="getPlaceholder()"></textarea>
        </div>

        <div class="modal__actions">
            <button class="modal__actions__cancel" type="button" (click)="close()">{{ t("cancel") }}</button>
            <button class="modal__actions__create" type="button" (click)="createComment()" [loading]="CreateCommentAction">{{ t("create") }}</button>
        </div>
    </div>
</ng-container>
